export default {
  displayName: 'Contractor Network Details Table',
  allowableParents: ['Section'],
};
